import { Navigate, useParams, useSearchParams } from 'react-router-dom';
import type { SupportedLanguage } from './lib/i18n/language-config.ts';

type LanguageRedirectProps = {
    urlLanguage: SupportedLanguage;
};

/**
 * Redirects the legacy /en and /de prefixes to the bare path, carrying the
 * language as `?lng=`.
 *
 * Examples:
 * - /en/customers -> /customers?lng=en
 * - /de -> /?lng=de
 *
 * Whether the language actually applies is a tenant decision
 * (`enableSettingsMenu`), and the tenant is unknown on this pre-auth route —
 * so the param defers that decision to LegacyLanguageUrl inside the app.
 */
export const LanguageRedirect: React.FC<LanguageRedirectProps> = ({ urlLanguage }) => {
    const { '*': path } = useParams();
    const [searchParams] = useSearchParams();

    const search = new URLSearchParams(searchParams);
    search.set('lng', urlLanguage);

    return <Navigate to={{ pathname: `/${path ?? ''}`, search: search.toString() }} replace />;
};
